const Menu = [
    {
        title: "Dashboard",
        group: "apps",
        icon: "home",
        name: "Dashboard",
        route: "dashboard",
        permission: ["admin","user"],
    },

    {
        title: "User",
        icon: "people",
        route:"user",     
        permission: ["admin",],
    },
    {
        title: "Zone",
        icon: "mdi-map-marker",
        route:"adzone",     
        permission: ["admin","user"],
    },
    {
        title: "Placement",
        icon: "mdi-city",
        route:"adplacement",     
        permission: ["admin","user"],
    },
    {
        title: "Ad",
        icon: "mdi-message",
        route:"ad",     
        permission: ["admin","user"],
    },
    {
        title: "AdCount",
        icon: "mdi-counter",
        route:"adcount",     
        permission: ["admin","user"],
    },
    {
        title: "AdCountPresta",
        icon: "mdi-run-fast",
        route:"presta",     
        permission: ["admin","user"],
    },
    {
        title: "UserAgent",
        icon: "mdi-face",
        route:"agent",     
        permission: ["admin","user"],
    },
    // {
    //     title: "Project",
    //     icon: "mdi-application",    
    //     route:"project",        
    //     permission: ["admin","user"],
    // },
    // {
    //     title: "Template",
    //     icon: "mdi-message",
    //     route:"template",                
    //     permission: ["admin","user"],
    // },
    // {
    //     title: "Subscriber",
    //     icon: "people",
    //     route:"subscriber",     
    //     permission: ["admin",],
    // },
  
    
    //  {
    //     title: "Subscriber",
    //     group: "banner",
    //     icon: "people",
    //     items: [
    //         { name: "banner_list", title: "banner_list", route: "banner" },
    //         { name: "banner_new", title: "banner_new", route: "banner_new" },
    //     ],
    //     permission: ["admin"],
    // },
    // {
    //     title: "Segmentation",
    //     icon: "mdi-chart-pie",        
    //     route:"merchant",
    //     permission: ["admin","user"]
    // },
    // {
    //     title: "API",
    //     icon: "mdi-api",        
    //     route:"member",
    //     permission: ["admin","user"]

    // },
];

// console.log(Menu);

module.exports = {
    Menu
};
